import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { getExperienceDetails } from '../utils/helpers/supabase.helpers'
import { AgamiExperience } from '../types/supabase'

interface UseUserExperienceDetailsParams {
  experienceId?: string
}

interface UseUserExperienceDetailsReturn {
  experienceDetails: AgamiExperience | null
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useUserExperienceDetails = ({
  experienceId,
}: UseUserExperienceDetailsParams): UseUserExperienceDetailsReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [experienceDetails, setExperienceDetails] = useState<AgamiExperience | null>(null)

  const fetchExperienceDetails = useCallback(async (): Promise<void> => {
    if (!experienceId || !user) return

    setIsLoading(true)
    const { data, error } = await getExperienceDetails({ experienceId })

    if (error || !data) {
      setIsLoading(false)
      return
    }

    setExperienceDetails(data)
    setIsLoading(false)
  }, [experienceId, user])

  useEffect(() => {
    if (!user || !experienceId) {
      return
    }

    fetchExperienceDetails()
  }, [user, experienceId, fetchExperienceDetails])

  return { experienceDetails, isLoading, refetch: fetchExperienceDetails }
}
